export default {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4010' || 'http://newtest.qbankmanager.com',
  siteUrl: process.env.REACT_APP_SITE_URL || 'http://localhost:3000',
  presentationUrl: process.env.REACT_APP_PRESENTATION_URL || 'http://localhost:3001',
  presentationUrlApi: process.env.REACT_APP_PRESENTATION_URL_API || 'http://localhost:1338',
  paddleClientToken: process.env.REACT_APP_PADDLE_CLIENT_TOKEN || 'test_e231d2537ff163dc1eb390ec13b',
  hashKey: 'qbm31',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '27744830721-r8lsog1sngittdh2bk3441f4fa6k020l.apps.googleusercontent.com',
};
